import { AutocompleteRenderInputParams, InputAdornment, TextField } from '@mui/material';
import { ChangeEventHandler, RefObject } from 'react';
import { DynamicIcon } from 'src/components';

export const FilterResultsTextField = ({
  handleOnChange,
  isTextFieldOpen,
  inputRef,
  value,
  setValue,
  params,
  placeholder = 'Filter results',
  onBlur,
}: {
  handleOnChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  inputRef: RefObject<HTMLElement | null>;
  isTextFieldOpen: boolean;
  value?: unknown;
  setValue?: React.Dispatch<React.SetStateAction<string>>;
  params?: AutocompleteRenderInputParams;
  placeholder?: string;
  onBlur?: () => void;
}) => {
  return (
    <TextField
      size="small"
      variant="standard"
      onChange={(event) => {
        setValue?.(event.target.value);
        handleOnChange?.(event);
      }}
      inputRef={inputRef}
      {...params}
      placeholder={placeholder}
      type="text"
      value={value}
      sx={{
        paddingTop: 0.5,
        width: !isTextFieldOpen ? 0 : '100%',
        transition: '0.2s width',
        overflow: 'hidden',
        marginBottom: 1,
      }}
      InputProps={{
        ...params?.InputProps,
        startAdornment: (
          <InputAdornment position="start">
            <DynamicIcon
              name="Search"
              sx={{
                paddingInline: 1,
                width: '1.5rem',
                height: '1.5rem',
              }}
            />
          </InputAdornment>
        ),
        onBlur,
      }}
    />
  );
};
